import request from "@/utils/leafletRequest";
import store from "@/store";
import { leafletApiURL,leafletApiURLV3 } from '@/utils/config'
function getBaseUrl(version) {
  console.log("versionversionversionversiondddd",version);
  
  if(version === 'v3'){
    return leafletApiURLV3;
  }else{
    return leafletApiURL;
  }
}
//获取活页式教材系统token
export function createPreviewSrc(data,version) {
  return request({
    url:
      getBaseUrl(version) +
      "/textBook/createPreviewSrc?businessType=" +
      data.businessType +
      "&looseLeafId=" +
      data.looseLeafId +
      "&pageType=" +
      data.pageType +
      "&textBookId=" +
      data.textBookId +
      "&tyleType=B" +
      "&isTrial=" +
      data.isTrial,
    method: "POST",
    data: data,
  });
}
//查询教材详细信息
export function getTextBookInfo(textBookId,version) {
  return request({
    url:
      getBaseUrl(version) +
      "/business/textBooks/getById?id=" +
      textBookId,
    method: "GET",
  });
}
//查询教材目录列表
export function getTextBookCatalog(textBookId, hiddenFlag, versionId,version) {
  return request({
    url:
      getBaseUrl(version) +
      "/business/catalog/list?textBookId=" +
      textBookId +
      "&hiddenFlag=" +
      hiddenFlag +
      "&versionId=" +
      versionId,
    method: "GET",
  });
}
//查询教材中的活页信息
export function getTextBookLooseLeaf(textBookId, versionId,version) {
  return request({
    url:
      getBaseUrl(version) +
      "/business/textBooks/getTextBookLooseLeaf?textBookId=" +
      textBookId +
      "&versionId=" +
      versionId,
    method: "GET",
  });
}

//查询活页信息
export function getLeaf(id,version) {
  return request({
    url: getBaseUrl(version) + "/business/looseLeaf/getById",
    method: "GET",
    params: { id },
  });
}
export function getGraphAnchorIndexList(params) {
  return request({
    url: getBaseUrl('v3') + "/business/positioning/list",
    method: "get",
    params,
  });
}
